// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* MultiSelectCombo 컴포넌트 */

.msc-wrap {
  position: relative;
  display: inline-block;
}

.msc-btn {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 5px 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
  background: white;
  font-size: 13px;
  cursor: pointer;
  min-width: 140px;
  max-width: 280px;
  text-align: left;
  color: #333;
  font-family: inherit;
  transition: border-color 0.15s;
}
.msc-btn:hover { border-color: #4a90e2; }

.msc-label {
  flex: 1 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.msc-caret { font-size: 10px; color: #888; flex-shrink: 0; }

.msc-dropdown {
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  min-width: 160px;
  border: 1px solid #ccc;
  border-radius: 4px;
  background: white;
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.13);
  z-index: 1000;
  max-height: 240px;
  overflow-y: auto;
}

.msc-item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 7px 12px;
  font-size: 13px;
  cursor: pointer;
  color: #333;
  -webkit-user-select: none;
          user-select: none;
}
.msc-item:hover { background: #f5f7ff; }
.msc-item input[type="checkbox"] {
  width: 14px;
  height: 14px;
  cursor: pointer;
  accent-color: #4a90e2;
  flex-shrink: 0;
}

.msc-item-all { font-weight: 600; color: #1a1a2e; }

.msc-sep {
  border: none;
  border-top: 1px solid #e8e8e8;
  margin: 2px 0;
}

.msc-empty {
  font-size: 12px;
  color: #999;
  padding: 8px 12px;
}
`, "",{"version":3,"sources":["webpack://./src/components/common/MultiSelectCombo.css"],"names":[],"mappings":"AAAA,0BAA0B;;AAE1B;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;EACX,oBAAoB;EACpB,8BAA8B;AAChC;AACA,iBAAiB,qBAAqB,EAAE;;AAExC;EACE,SAAO;EACP,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA,aAAa,eAAe,EAAE,WAAW,EAAE,cAAc,EAAE;;AAE3D;EACE,kBAAkB;EAClB,qBAAqB;EACrB,OAAO;EACP,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,0CAA0C;EAC1C,aAAa;EACb,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,WAAW;EACX,yBAAiB;UAAjB,iBAAiB;AACnB;AACA,kBAAkB,mBAAmB,EAAE;AACvC;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,qBAAqB;EACrB,cAAc;AAChB;;AAEA,gBAAgB,gBAAgB,EAAE,cAAc,EAAE;;AAElD;EACE,YAAY;EACZ,6BAA6B;EAC7B,aAAa;AACf;;AAEA;EACE,eAAe;EACf,WAAW;EACX,iBAAiB;AACnB","sourcesContent":["/* MultiSelectCombo 컴포넌트 */\n\n.msc-wrap {\n  position: relative;\n  display: inline-block;\n}\n\n.msc-btn {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 5px 10px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  background: white;\n  font-size: 13px;\n  cursor: pointer;\n  min-width: 140px;\n  max-width: 280px;\n  text-align: left;\n  color: #333;\n  font-family: inherit;\n  transition: border-color 0.15s;\n}\n.msc-btn:hover { border-color: #4a90e2; }\n\n.msc-label {\n  flex: 1;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.msc-caret { font-size: 10px; color: #888; flex-shrink: 0; }\n\n.msc-dropdown {\n  position: absolute;\n  top: calc(100% + 4px);\n  left: 0;\n  min-width: 160px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  background: white;\n  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.13);\n  z-index: 1000;\n  max-height: 240px;\n  overflow-y: auto;\n}\n\n.msc-item {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 7px 12px;\n  font-size: 13px;\n  cursor: pointer;\n  color: #333;\n  user-select: none;\n}\n.msc-item:hover { background: #f5f7ff; }\n.msc-item input[type=\"checkbox\"] {\n  width: 14px;\n  height: 14px;\n  cursor: pointer;\n  accent-color: #4a90e2;\n  flex-shrink: 0;\n}\n\n.msc-item-all { font-weight: 600; color: #1a1a2e; }\n\n.msc-sep {\n  border: none;\n  border-top: 1px solid #e8e8e8;\n  margin: 2px 0;\n}\n\n.msc-empty {\n  font-size: 12px;\n  color: #999;\n  padding: 8px 12px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
